import { Link } from 'react-router-dom'

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20anime%20style%20illustration%20with%20dramatic%20lighting%2C%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20warm%20golden%20sunset%20sky%2C%20traditional%20Japanese%20architecture%20silhouette%2C%20dreamy%20atmospheric%20mood%2C%20high%20quality%20digital%20art%2C%20soft%20gradients%2C%20cinematic%20composition%2C%20beautiful%20landscape%20wallpaper&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="色里番精选推荐"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-line text-accent-400"></i>
            <span className="text-sm text-background-50/90">精选 5000+ 优质色里番作品</span>
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-6 leading-tight">
            探索色里番的
            <span className="text-primary-400">完整世界</span>
          </h1>
          <p className="text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            精选高品质色里番作品分类导航，涵盖热门番剧、新番推荐、经典回顾等内容。
            为色里番爱好者提供一站式资源发现平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/hot"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line mr-2"></i>
              探索热门推荐
            </Link>
            <Link
              to="/category/new"
              className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-base hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-rocket-line mr-2"></i>
              查看新番速递
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}